'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _functional = require('../utils/functional');

var _utils = require('../utils');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ProductMobile = function ProductMobile(el) {
  (0, _classCallCheck3.default)(this, ProductMobile);

  window.addEventListener('scroll', function () {
    var mobileBtn = document.querySelector('.prd-ProductOffers_Submit-mobile');

    if (window.innerWidth <= _utils.mediaBreakpoints.md) {
      if (window.pageYOffset > 850) {
        mobileBtn.classList.add('prd-ProductOffers_Submit-mobileShow');
      } else if (window.pageYOffset < 850) {
        mobileBtn.classList.remove('prd-ProductOffers_Submit-mobileShow');
      }
    }
  }, false);
};

exports.default = ProductMobile;